import { GlobalState } from 'store/types';

export const getMerchantSettings = (state: GlobalState) => state.merchantSettings;

export const getIsPendingSettings = (state: GlobalState) => getMerchantSettings(state).pending;
export const getIsInitialPendingSettings = (state: GlobalState) => getMerchantSettings(state).initialPending;
